<template>
    <div class="upload-picture-modal">
        <b-modal
            id="id-card-preview-popup"
            title="Document Preview"
            size="md"
            ok-title="Download"
            cancel-title="Close"
            ok-variant="primary"
            no-close-on-backdrop
            no-close-on-esc
            @ok="onClick"
        >
            <h5>ID Card</h5>

            <div class="document-preview-section">
                <div
                    v-if="item && item.fileName && ext == 'pdf'"
                    class="preview-video text-center identification-section"
                >
                    <!-- <pdf :src="pdfSrc" @num-pages="0"></pdf> -->

                    <pdf
                        style="display: none"
                        :src="pdfSrc"
                        @num-pages="pageCount = new Array($event)"
                    />
                    <!-- Actual document -->
                    <pdf
                        v-for="(page, index) in pageCount"
                        :key="index"
                        :src="pdfSrc"
                        :page="index + 1"
                     
                    />
                </div>
                <div v-else>
                    <img v-authenticated-image="item.fileName" />
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
import pdf from 'vue-pdf'
import axios from 'axios'

export default {
    components: {
        pdf,
    },
    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {
        item: {
            type: Object,
            default: null,
        },
    }, // End of Component > props
    data() {
        return {
            pdfSrc: process.env.VUE_APP_FILE_SERVICE_URL + this.item.fileName,
            ext:  this.item.fileName? this.item.fileName.split('.').pop() : null,
            pageCount: []
        }
    },
    methods: {
        onClick() {
            axios({
                url: this.pdfSrc,
                method: 'GET',
                responseType: 'blob',
            }).then((response) => {
                const ext = (this.ext || '').toLowerCase()
                const fileName = ['pdf', 'jpg', 'jpeg', 'png'].includes(ext)
                    ? `IDCard.${ext}`
                    : 'IDCard'

                // Use the Blob axios already gives us as-is — re-wrapping it via
                // `new Blob([response.data], {...})` breaks the download in some
                // browsers, causing a navigation to the blob: URL instead of a save.
                const fileURL = window.URL.createObjectURL(response.data)
                const fileLink = document.createElement('a')
                fileLink.href = fileURL
                fileLink.download = fileName
                document.body.appendChild(fileLink)
                fileLink.click()
                document.body.removeChild(fileLink)
                URL.revokeObjectURL(fileURL)
            })
        }
    }
}
</script>
